import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';

interface UpdateMemberRoleData {
  teamId: string;
  userId: string;
  role: 'admin' | 'member';
}

const useUpdateMemberRole = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ teamId, userId, role }: UpdateMemberRoleData) => {
      await Api.updateMemberRole(teamId, userId, { role });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['teams', 'single', variables.teamId] });
      queryClient.invalidateQueries({ queryKey: ['teams', 'list'] });
      toast.success('Role updated', { description: 'Team member role has been updated.' });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to update member role',
      });
    },
  });
};

export default useUpdateMemberRole;
